import { AccountState, AccountType } from "core/auth/auth.entity";
import { ApiAdRecord } from "core/orderAd/orderAd.entity";
import { useMemo } from "react";
import { useAppSelector } from "utils/store";
import { useMyPanel } from "./useMyPanel";

const OneMonthThreshold = 5_000_000;

export function useNeedAuth(): { isOrganization: boolean, needsAuth: boolean, isAuthenticating: boolean, isAboveThreshold: boolean } {
  const myPanel = useMyPanel();
  const ads = useAppSelector((state) => state.ordersList.orders);

  const thisMonthAds = useMemo<ApiAdRecord[]>(
    () =>
      ads.filter((ad) => {
        return new Date(ad.start_time).getMonth() === new Date().getMonth();
      }),
    [ads]
  );

  const sumOfAds = thisMonthAds.reduce((acc, ad) => acc + ad.payed_price, 0)

  if (myPanel.type === AccountType.Personal) {
    return {
      isOrganization: false,
      needsAuth: myPanel.shahkar_validated === false,
      isAuthenticating: false,
      isAboveThreshold: sumOfAds > OneMonthThreshold,
    };
  } else {
    return {
      isOrganization: true,
      needsAuth: myPanel.state !== AccountState.Active,
      isAuthenticating:
        myPanel.state === AccountState.AwaitingVerification ||
        myPanel.state === AccountState.DocsRejected,
      isAboveThreshold: sumOfAds > OneMonthThreshold,
    };
  }
}
